import { Platform } from 'react-native';
import api from '../axios';
import constants from '@/config/constants';
import { ErrorInfo } from 'react';
import { generateDeviceInfo } from '@/api/services/logToSentry';
import { logger as loggerSentry } from '@sentry/react-native';

export const postInfoLogs = async (
  error?: Error,
  reactErrorInfo?: ErrorInfo,
  incidentId?: string,
) => {
  const userAgent = Platform.OS === 'web' ? navigator.userAgent : undefined;
  const deviceInfo = await generateDeviceInfo();

  const infoLogs: InfoLogs = {
    app: {
      version: constants.appVersion,
      product: 'aphasia',
      productDetail: constants.appMode,
      appType:
        Platform.OS === 'ios' ||
        Platform.OS === 'android' ||
        Platform.OS === 'web'
          ? Platform.OS
          : null,
    },
    device: {
      userAgent: userAgent,
      ...(!userAgent && deviceInfo),
    },
    error: error
      ? {
          incidentId: incidentId,
          message: `${error.message} # ${reactErrorInfo?.componentStack}`,
          stack: error.stack,
        }
      : undefined,
  };

  // If sentry is enabled and if the error is not just informations send from the patient then, we log it to Sentry
  if (error || reactErrorInfo || incidentId) {
    // Rename 'error' to 'logDetails' for Sentry only
    const { error: logDetails, ...restInfoLogs } = infoLogs;
    loggerSentry.error(`Error from infoLogs ${incidentId}`, {
      ...restInfoLogs,
      logDetails,
    });
  }

  return api
    .post(`/api/info-logs`, [infoLogs])
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

interface InfoLogs {
  user?: string;
  error?: {
    incidentId?: string | null;
    message?: string | null;
    stack?: string | null;
    platformStack?: string | null;
  };
  app?: {
    version?: string | null;
    product?: 'aphasia' | null;
    productDetail?: string | null;
    appType?: 'ios' | 'android' | 'web' | null;
  };
  device?: {
    brand?: string | null;
    designName?: string | null;
    deviceName?: string | null;
    deviceType?: number | null;
    deviceYearClass?: number | null;
    isDevice?: boolean | null;
    manufacturer?: string | null;
    modelId?: string | null;
    modelName?: string | null;
    osBuildFingerprint?: string | null;
    osBuildId?: string | null;
    osInternalBuildId?: string | null;
    osName?: string | null;
    osVersion?: string | null;
    platformApiLevel?: number | null;
    supportedCpuArchitectures?: string[] | null;
    totalMemory?: number | null;
    userAgent?: string | null;
    freeDiskStorage?: string | null;
  };
}
